import { QueryClientProvider } from '@tanstack/react-query'
import ApiProvider from 'ply-api/Provider'
import AuthProvider from 'ply-auth/provider'
import { createQueryClient } from 'ply-shared/query'
import { AdblockGatekeeper } from 'ply-ux/adblock-gatekeeper/adblock-gatekeeper'
import { Provider as SnackbarProvider } from 'ply-ux/Snackbar'
import { BrowserRouter as Router } from 'react-router'
import Root from './Root'
import { ColorModeProvider } from './theme'

const queryClient = createQueryClient()

const endpoints = {
	getAuthServiceUrl: () => 'api/auth/service/url',
	getUser: () => '/api/auth/info',
	forgotPassword: () => '/api/auth/forgot',
	resetPassword: () => '/api/auth/reset',
	login: () => '/api/auth/login',
	logout: () => '/api/auth/logout',
}

export default function App() {
	return (
		<ColorModeProvider>
			<QueryClientProvider client={queryClient}>
				<ApiProvider baseURL="/api">
					<SnackbarProvider>
						<AdblockGatekeeper>
							<AuthProvider endpoints={endpoints}>
								<Router>
									<Root />
								</Router>
							</AuthProvider>
						</AdblockGatekeeper>
					</SnackbarProvider>
				</ApiProvider>
			</QueryClientProvider>
		</ColorModeProvider>
	)
}
